import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { FronteggProvider } from "@frontegg/react";
import { UserProvider } from "./contexts/UserContext";
import { UserProgressProvider } from "./contexts/UserProgressContext";
import {
  PreviewSessionProvider,
  readStoredPreviewToken,
} from "./contexts/PreviewSessionContext";
import App from "./App.tsx";
import SignUp from "./pages/signup/SignUp";
import TermsPage from "./pages/terms/TermsPage";
import PreviewPage from "./pages/preview";
import PreviewEnded from "./pages/preview/PreviewEnded";
import "./index.css";

const contextOptions = {
  baseUrl: "https://app-6yutcyqk6ant.us.frontegg.com",
  clientId: "af20fef1-c350-4b74-ac85-af1538eb4c38",
  appId: "50714f08-fbf2-4ce9-9b6d-d53047540165",
};

const isSignupPage = window.location.pathname === "/signup";
const isTermsPage = window.location.pathname === "/terms";
const isPreviewEntry = window.location.pathname.startsWith("/preview/");
const isPreviewEnded = window.location.pathname === "/preview-ended";
const storedPreviewToken = readStoredPreviewToken();
const isMultiPagePreview =
  !isPreviewEntry && !isSignupPage && !isTermsPage && !isPreviewEnded && !!storedPreviewToken;

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      {isSignupPage ? (
        <SignUp />
      ) : isTermsPage ? (
        <TermsPage />
      ) : isPreviewEnded ? (
        <PreviewEnded />
      ) : isPreviewEntry ? (
        <PreviewPage />
      ) : isMultiPagePreview ? (
        <PreviewSessionProvider initialToken={storedPreviewToken!}>
          <App />
        </PreviewSessionProvider>
      ) : (
        <FronteggProvider contextOptions={contextOptions} hostedLoginBox={true}>
          <UserProvider>
            <UserProgressProvider>
              <App />
            </UserProgressProvider>
          </UserProvider>
        </FronteggProvider>
      )}
    </BrowserRouter>
  </React.StrictMode>
);
